export default __webpack_public_path__ + "static/media/4_thumb.5259c011.svg";